export default "__VITE_ASSET__DBH5fsZd__"